import { render } from "./add-material.vue?vue&type=template&id=709f19d6&scoped=true"
import script from "./add-material.vue?vue&type=script&lang=js"
export * from "./add-material.vue?vue&type=script&lang=js"

import "./add-material.vue?vue&type=style&index=0&id=709f19d6&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-709f19d6"]])

export default __exports__